import { useSubscription } from '@apollo/client/react'

import { PaymentTransactionStatusDocument } from '../../../../../../api/graphql/generated/types'
import { useSubscriptionRetry } from '../../../../../../hooks/useSubscriptionRetry'

/**
 * Custom hook for subscribing to payment transaction status changes
 * Automatically handles subscription retries for network errors
 *
 * @param transactionId - The ID of the payment transaction to subscribe to
 * @returns Object containing transaction data, loading state, and error state
 */
export const usePaymentTransactionStatus = (transactionId: string) => {
  const { data, loading, error, restart } = useSubscription(
    PaymentTransactionStatusDocument,
    {
      variables: { transactionId },
      skip: !transactionId,
    },
  )

  const transaction = data?.paymentTransactionStatus

  useSubscriptionRetry({
    error,
    restart,
    subscriptionName: 'Payment Transaction Status subscription',
  })

  return {
    transaction,
    loading,
    error,
  }
}
